<template>
  <v-layout row wrap>
    <v-flex xs2 sm1>

      <v-menu
          ref="menu"
          lazy
          :close-on-content-click="true"
          v-model="menu"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-right="40"
          min-width="290px"
          :return-value.sync="date"
        >

        <v-icon class="fix-icon-position" slot="activator">event</v-icon>

        <v-date-picker
          locale="pt-BR"
          :show-current="showCurrent"
          v-model="date"
          no-title
          scrollable>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="menu = false">{{$t('global.cancel')}}</v-btn>
          <v-btn flat color="primary" @click="$refs.menu.save(date)">{{$t('global.ok')}}</v-btn>
        </v-date-picker>

      </v-menu>
    </v-flex>

    <v-flex xs10 sm11 class="fix-field-position">
      <v-text-field
        v-mask="displayMask"
        :error-messages="errorMessages"
        :label="label" v-model="formatedDate"></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment';
  import { Global } from '@/Config';

  export default {
    model: {
      prop: 'parentModel',
      event: 'parentModelChange',
    },
    props: {
      parentModel: {
        required: true,
      },
      label: {
        type: String,
        default: 'Data',
      },
      innerFormat: {
        type: String,
        default: Global.format.parseDate,
      },
      displayFormat: {
        type: String,
        default: Global.format.displayDate,
      },
      displayMask: {
        type: String,
        default: '##/##/####',
      },
      showCurrent: {
        type: Boolean,
        default: false,
      },
      errorMessages: {
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        date: null,
        menu: false,
        formatedDate: null,
      };
    },
    created() {
      if (this.parentModel) {
        this.date = moment(this.parentModel, this.innerFormat).format(this.innerFormat);
      }
    },
    methods: {
      formatToInput(value) {
        if (value) {
          return moment(value).format(this.displayFormat);
        }

        return null;
      },
      parseToCalendar(value) {
        if (value) {
          return moment(value, this.displayFormat).format(this.innerFormat);
        }

        return null;
      },
    },
    watch: {
      formatedDate: {
        handler(newValue) {
          if (newValue.length === 10) {
            const date = this.parseToCalendar(newValue);
            if (date && date !== 'Invalid date') {
              this.date = date;
            } else {
              this.formatedDate = '';
              this.date = '';
            }
          }
        },
        deep: true,
      },
      date: {
        handler(newValue, oldValue) {
          if (newValue && newValue.trim().length && newValue !== oldValue) {
            this.formatedDate = this.formatToInput(newValue);
            this.$emit('parentModelChange', newValue);
          }
        },
        deep: true,
      },
    },
  };

</script>

<style scoped>
  .fix-icon-position {
    margin-top: 22px !important;
  }
  .fix-field-position {
    padding-left: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/PrDate.vue